<div class="row g-0 w-100">
    <div class="col-7">
        <div class="bg-white me-4 br-t-8 br-b-8 pb-4">
            <div class="pt-4 mx-4">
                <h6 class="fs-5 mb-0">Call Availability</h6>
                <small>Configuration of the availability to answer calls</small>
            </div>
            <hr>
            <div class="mx-4">
                <div class="pb-3">
                    <h5 class="fs-sm mb-0">Days</h5>
                    <small>Configuration of the availability to answer calls</small>
                </div>
                <app-inline-menu themeCss="--small" (menuClicked)="toggleDaySelection($event)" [menuItems]="weekDaysItems"></app-inline-menu>
                <div class="py-3">
                    <h5 class="fs-sm mb-0">Hours</h5>
                    <small>Select your available hours during the day.</small>
                </div>

                <div class="d-flex" *ngFor="let workHours of weekDaysItems[activeWeekDay].hours; let i=index">
                    <div>
                        <small class="fs-xs ms-3 mb-0">From:</small>
                        <app-time-picker [(initialTime)]="workHours.from"></app-time-picker>
                    </div>
                    <div class="mx-3">
                        <small class="fs-xs ms-3 mb-0">To:</small>
                        <app-time-picker [(initialTime)]="workHours.to"></app-time-picker>
                    </div>
                    <svg-icon src="assets/images/call/trash-can-icon.svg" svgClass="svg-icon" class="align-self-center mt-3 hover" (click)="removeAvailableHours(i)"></svg-icon>
                </div>

                <button
                    type="button"
                    class="btn-styled--secondary icon mt-2"
                    (click)="addAvailableTimes()"
                >
                    <svg-icon src="assets/images/call/plus-sign-icon.svg" svgClass="svg-icon"></svg-icon>
                    Add more availabilities
                </button>

                <div class="pb-3 mt-4">
                    <h5 class="fs-sm mb-0">After-Call Work</h5>
                    <small>Unavailability time after a call.</small>
                </div>
                <ng-select class="me-3" style="min-width: 218px;" placeholder="All calls"
                           [clearable]="false"
                           [searchable]="false"
                           [(ngModel)]="userCallTimeOut"
                >
                    <ng-option [value]="callType.value" *ngFor="let callType of [
                        {value: '-1', name: 'None'},
                        {value: '300', name: '5 minutes'},
                        {value: '600', name: '10 minutes'},
                        {value: '1800', name: '30 minutes'}
                        ]">
                        {{ callType.name | capitalize }}
                    </ng-option>
                </ng-select>
                <div class="mt-3 d-flex">
                    <a class="btn btn-styled btn-sm" [ngClass]="{'loading': isLoading}" (click)="!isLoading && saveAvailableHours()">Update</a>
                </div>
            </div>
        </div>
    </div>
    <div class="col-5 bg-white br-t-8 br-b-8">
        <div class="pt-4 mx-4">
            <h6 class="fs-5 mb-0">Mobility</h6>
            <small>Out-of-office call settings. </small>
        </div>
        <hr>
        <div class="mx-4">
            <div class="row w-100">
                <div class="col-7">
                    <div class="pb-3">
                        <h5 class="fs-sm mb-0">Activate an alternative call phone</h5>
                        <small>Activate an alternative call phone</small>
                    </div>
                </div>
                <div class="col-5">
                    <a class="me-2 pt-1">
                        <i class="toggle fa"
                           [ngClass]="{
                                    'fa-toggle-on text-success': useAlternativePhone === true,
                                    'fa-toggle-off' : useAlternativePhone === false
                                    }"
                           (click)="useAlternativePhone = !useAlternativePhone"
                        ></i>
                    </a>
                </div>
            </div>
            <div class="row w-100">
                <label class="padded-top-gray-label">Alternative Phone Number:</label>
                <ys-phone-input [disabled]="useAlternativePhone === false"
                                [(ngModel)]="alternativePhone"
                ></ys-phone-input>
            </div>

            <div class="row w-100" *ngIf="user.callRing === 1">
                <div>
                    <div class="pb-3 mt-4">
                        <h5 class="fs-sm mb-0">Twilio numbers</h5>
                        <small>Select your inbound/outbound twilio numbers</small>
                    </div>
                </div>
                <div>
                    <ng-container *ngIf="availableNumbers">

                        <div class="mb-3 row" *ngFor="let domain of availableNumbersKeys">
                            <label class="col-sm-3 col-form-label">{{ domain | capitalize }} (private)</label>
                            <small>Dafault:{{ defaultNumber[domain].phone | formatPhone }}</small>
                            <div class="col-10 col-sm-7">
                                <ng-select [(ngModel)]="userDomainNumbersMap[domain].id">
                                    <ng-option
                                            *ngFor="let twilioPhone of availableNumbers[domain]"
                                            [value]="twilioPhone.id">
                                        {{ twilioPhone.phone | formatPhone }}
                                    </ng-option>
                                </ng-select>
                            </div>
                            <div class="col-2">
                                <input class="form-check-input" type="checkbox"
                                       title="If selected will lock this number to only this user"
                                       [(ngModel)]="userDomainNumbersMap[domain].isPrivate"
                                >
                            </div>
                        </div>

                    </ng-container>
                </div>
            </div>


            <div class="row w-100">
                <div class="pb-3 mt-4">
                    <h5 class="fs-sm mb-0">Incoming office ringtone</h5>
                    <small>You can select a ringtone you like.</small>
                </div>
                <ng-select class="me-3" style="min-width: 218px;" placeholder="Ring tone"
                           [clearable]="false"
                           [searchable]="false"
                           [(ngModel)]="userInboundRingtone"
                           [items]="inboundRingtones"
                           bindLabel="path" bindValue="path"
                           (change)="stopPlayback()"
                           (blur)="stopPlayback()"
                >
                    <ng-template ng-label-tmp let-item="item">
                        {{item.name}}
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                        <span class="d-flex justify-content-between" style="line-height: 32px">
                            <span>{{item.name}}</span>
                            <span class="me-4">
                                <svg-icon *ngIf="playing != item.name"
                                          (click)="initPlaybackRecord($event, item)"
                                          class="hover position-absolute"
                                          src="assets/images/call/play-icon.svg"
                                          @fadeIn
                                          @fadeOut></svg-icon>
                                <svg-icon *ngIf="playing == item.name"
                                          (click)="stopPlayback($event)"
                                          class="hover position-absolute"
                                          src="assets/images/call/stop-icon.svg"
                                          @fadeIn
                                          @fadeOut></svg-icon>
                            </span>
                        </span>
                    </ng-template>


                </ng-select>
            </div>
        </div>
    </div>
</div>
